export const mapLoggedInAndImpersonatedUserFromApi = ({
  ImpersonatedUser, LoggedInUser, preLaunchUser
}) => ({
  UserId: LoggedInUser.UserId,
  UserRoleId: LoggedInUser.UserRole,
  CityID: LoggedInUser.CityID,
  FirstName: LoggedInUser.FirstName,
  LastName: LoggedInUser.LastName,
  Email: LoggedInUser.Email,
  LastCompletedStep: LoggedInUser.LastCompletedStep,
  PhoneNumber: ImpersonatedUser.PhoneNumber,
  TotalOrdersPerMonth: ImpersonatedUser.NumberOfShipmentsPerMonth,
  ImpersonatedUserId: ImpersonatedUser.UserId,
  ImpersonatedEmail: ImpersonatedUser.Email,
  ImpersonatedRoleId: ImpersonatedUser.UserRole,
  IsAdmin: LoggedInUser.IsAdmin,
  IsOnboarding: ImpersonatedUser.IsOnboarding,
  CompanyName: LoggedInUser.CompanyName,
  ImpersonatedCompanyName: ImpersonatedUser.CompanyName,
  preLaunchUser,
  defaultStoreIntegrationId: ImpersonatedUser.DefaultStoreIntegrationId
})
